import TransitionText from "../components/TransitionText";
import Fatemeh from "../assets/images/fatemeh.jpg";
import Code from "../assets/icons/Code";
import Fragment from "../assets/icons/Fragment";
import BinaryNumbers from "../assets/icons/BinaryNumbers";
import { dict } from "../const/dict";

const AboutMe = () => {
  return (
    <div className="section page-container">
      <div className="flex xl:gap-32 flex-col xl:flex-row-reverse gap-4">
        <img src={Fatemeh} alt="fatemeh" className="xl:rounded-b-full xl:border-t xl:w-[500px] w-96" />
        <div className="flex flex-col justify-start xl:min-w-[608px]">
          <p className="text-xl xl:text-2xl">Hello there!</p>
          <TransitionText text={dict.iAmFatemeh} wrapperClassName=" xl:mt-4 text-3xl" />
          <TransitionText text={dict.frontEndDeveloper} wrapperClassName=" xl:mt-2 text-xl" />
          <p className="text-description xl:mt-5">
            {dict.about1}
            <br />
            {dict.about2}
            <br />
            {dict.about3}
            <br />
            {dict.about4}
          </p>
          <a
            download={"fatemeRasolzade.pdf"}
            className="text-lg xl:text-xl text-main-blue xl:mt-4 cursor-pointer icon-transition"
            href={"../assets/documents/resume.pdf"}
          >
            {dict.downloadCV}
          </a>
        </div>
      </div>
      <Fragment className={"absolute -top-56 left-[107rem] blur-[6px] text-main-orange"} />
      <Code className={"absolute top-[23.4rem] left-[67rem] blur-[6px]"} />
      <BinaryNumbers className={"absolute -top-[5rem] -left-16 blur-[6px]"} />
    </div>
  );
};

export default AboutMe;
